import { createContext, useContext } from 'react'

type FormWizardContextType = {
  data?: number[] | null
  currentStep: number
  nextStep: (data?: number[]) => void
  prevStep: () => void
}

export const FormWizardContext = createContext<FormWizardContextType>({
  data: null,
  currentStep: 0,
  nextStep: () => {
    // default implementation
  },
  prevStep: () => {
    // default implementation
  }
})

export const useFormWizard = () => useContext(FormWizardContext)
